import { Injectable } from '@angular/core';
import { ConsentGroupsUserService } from '@swagger-services/consent';
import { environment } from '../../../../environments/environment';
import { ModalService } from '@services/modal.service';
import { ConsentDialogComponent } from '../components/consent-dialog/consent-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConsentService {
  constructor(
    private readonly consentGroupsUserService: ConsentGroupsUserService,
    private readonly modalService: ModalService,
  ) {}

  async isGroupSigned(key: string): Promise<boolean> {
    const signatureStatus = await this.consentGroupsUserService.consentGroupControllerGetSignatureStatus(
      environment.orgSlug,
      key,
    );
    return signatureStatus.isSigned;
  }

  async requestSignature(key: string): Promise<string[] | undefined> {
    return await this.modalService.openModal(ConsentDialogComponent, { key });
  }
}
